import noActiveSeriesImage from '../../../../asset/image/no-active-series.png'
import { SuggestedSeriesDismissDialog } from 'src/component/lets-get-moving/suggested-series-dismiss-dialog'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { EmptyState } from 'src/component/profile/empty-state/empty-state'
import { ProfileSection } from 'src/component/profile/profile-section/profile-section'
import { OutlinedButton } from 'src/component/ui/button'
import { Grid } from 'src/component/ui/grid/grid'
import { SeeAll } from 'src/component/ui/see-all'
import { SeriesCardActive, SeriesCardSkeleton } from 'src/component/ui/series-card'
import { HustlerProgramme, Programme } from 'src/dao/core-dao'
import { useCancelActiveProgramme } from 'src/hook/use-cancel-active-programme'
import { useProfileSection } from 'src/hook/use-profile-section'
import { useMyStartedProgrammes } from 'src/hook/use-programmes'
import { toasterUtil } from 'src/util/toaster-util'

export const ActiveSeries = (): React.ReactElement => {
  const [programmePendingCancel, setProgrammePendingCancel] = useState<Programme | null>(null)
  const cancelMutation = useCancelActiveProgramme()
  const {
    data: activeSeries,
    isLoading,
    isError,
  } = useMyStartedProgrammes({
    onError: () => {
      toasterUtil.error('We are having difficulties loading your active series, please try again.')
    },
  })

  const { items, isEmpty, hasMore, shouldShowSkeleton } = useProfileSection<HustlerProgramme, Programme>({
    data: activeSeries,
    isLoading,
    isError,
    extractItem: (hp) => hp.programme,
  })

  return (
    <ProfileSection theme="light">
      <ProfileSection.Header>
        <ProfileSection.Title>ACTIVE SERIES</ProfileSection.Title>
        {!isLoading && !isError && hasMore && <SeeAll seeAllLink="/active-series" theme="light" />}
      </ProfileSection.Header>

      <ProfileSection.Content
        isLoading={shouldShowSkeleton}
        isEmpty={isEmpty}
        skeleton={
          <Grid.Skeleton>
            <SeriesCardSkeleton variant="active" />
          </Grid.Skeleton>
        }
        empty={
          <EmptyState
            theme="light"
            image={noActiveSeriesImage}
            message="No active series found, please explore our list of series!"
            action={
              <OutlinedButton asChild className="border-ivory text-ivory">
                <Link to="/programmes">SEE ALL SERIES</Link>
              </OutlinedButton>
            }
          />
        }
      >
        <Grid
          items={items}
          keyExtractor={(p) => p.id}
          renderItem={(programme) => (
            <SeriesCardActive series={programme} onCancelSeriesClick={() => setProgrammePendingCancel(programme)} />
          )}
        />
        <SuggestedSeriesDismissDialog
          isOpen={programmePendingCancel !== null}
          onClose={() => setProgrammePendingCancel(null)}
          onDismiss={() => {
            if (!programmePendingCancel) {
              return
            }
            const programme = programmePendingCancel
            cancelMutation.mutate({ programmeId: programme.id, programme }, { onSettled: () => setProgrammePendingCancel(null) })
          }}
          isSubmitting={cancelMutation.isLoading}
        />
      </ProfileSection.Content>
    </ProfileSection>
  )
}
